import { createSelector } from 'reselect';

export const isLoading = createSelector(
  state => state.loading,
  loading => !!loading
);
